import React from "react";

import { Main, Overlay, Content, Header, Body} from "./Styles";

class Modal extends React.Component{
    constructor(props){
        super(props);

        this.keyScape = this.keyScape.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if (this.props.isVisible){
            document.removeEventListener('keydown', this.keyScape);
        } else{
            document.addEventListener('keydown', this.keyScape);
        }
    }
    keyScape(e){
        if (e.key === 'Escape' || e.keyCode === 27) {
            this.props.onClose();
        }
    }
    render(){
        const { 
            isVisible = false, 
            title = "", 
            children = null, 
            onClose = ()=>{}
        } = this.props;
        if (!isVisible){
            return null;
        }

        return (
            <Main>
                <Content className={this.props.className}>
                    <Header>
                        <h4 className="title">{title}</h4>
                        <button className="btn-close" onClick={onClose}>
                            <i className="fas fa-times" />
                        </button>
                    </Header>
                    <Body>
                        {children}
                    </Body>
                </Content>
                <Overlay onClick={onClose} />
            </Main>
        )
    }
}

export default Modal;